module.exports = __webpack_public_path__ + "static-v-shop/1786468182979/img/mercadopago-logo.f9ae46a8.webp";